/*
 * Copyright (c) SEQTA Software 2018.
 *
 * Created by simon on 2018-06-19
 */

import {createSelector} from 'reselect';
import {getRouterParams} from '../router.selectors';

export const setItemsSelector = state => state.syllabus && state.syllabus.sets && state.syllabus.sets.items;
export const setRetrievingSelector = state => state.syllabus && state.syllabus.sets && state.syllabus.sets.retrieving;
export const isSetSaving = state => state.syllabus && state.syllabus.sets && state.syllabus.sets.saving;
export const getSelectedSetID = (state, ownProps) => {
	const params = getRouterParams(state, ownProps);
	return params && params.setID;
};

export const getSelectedSet = createSelector(
	setItemsSelector,
	getSelectedSetID,
	(items, setID) => items && items.find(item => item.uuid === setID)
);

/**
 * Sort syllabus sets alphanumerically and case insensitively by name.
 */
export const getSortedSets = createSelector(
	setItemsSelector,
	sets => sets && sets.sort((a, b) => a.name.localeCompare(b.name))
);

/**
 * No other set shares the selected sets name
 */
export const hasUniqueName = createSelector(
	setItemsSelector,
	getSelectedSet,
	(items, selectedSet) => items && selectedSet && !items.find(item => item.uuid !== selectedSet.uuid && selectedSet.name === item.name)
);

/**
 * The current syllabus set is valid and can be saved
 */
export const canSaveSet = createSelector(
	hasUniqueName,
	nameIsUnique => !!nameIsUnique
);


// WEBPACK FOOTER //
// ./src/syllabus/set.selectors.js